
import { reducer as appSetting } from './systems';
import { reducer as authen } from './authen';
import { reducer as attribute } from './attribute';
import { reducer as brand } from './brand';
import { reducer as category } from './category';
import { reducer as products } from './products';
import { reducer as register } from './register';
import { reducer as profile } from './profile';
import { reducer as cmsAuth } from './cms/authen_cms';
import { reducer as masterCategory } from './master-category';
import { reducer as masterBrand } from './master-brand';
import { reducer as masterProduct } from './master-product';
import { reducer as internalCategory } from './internal-category';
import { reducer as branch } from './branch';
import { reducer as homeManagement } from './home-management';
import { reducer as member } from './member';
import { reducer as order } from './order';
import { reducer as rolePermission } from './role-permission';
import { reducer as report } from './report';
import { reducer as coupons } from './coupons';
import { reducer as bigPoint } from './big-point';

export default {
  appSetting,
  authen,
  attribute,
  brand,
  category,
  products,
  register,
  profile,
  cmsAuth,
  masterCategory,
  masterBrand,
  masterProduct,
  internalCategory,
  branch,
  homeManagement,
  member,
  order,
  rolePermission,
  report,
  coupons,
  bigPoint
};
